import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalMarketplace from "@faire/web-api--source/routes/brand-portal/marketplace";
import brandPortalShopSettings from "@faire/web-api--source/routes/brand-portal/my-shop/settings";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";

export const PauseShopIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="If you need to take time away or temporarily stop accepting new orders, you can place your shop on pause for up to 12 weeks at a time. When your shop is paused, retailers won’t be able to place orders with you until you’re back, but your shop will still be visible. Customers can browse your offerings, learn about your brand, and see your shop’s return date."
          description={{
            text: "Introduction to pausing your shop",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="Here’s how to put your shop on pause:"
          description={{
            text: "Header of the list in how to pause your shop",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <ol>
        <LiItem step={1}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Navigate to the <LinkFormatting>Marketplace</LinkFormatting> tab."
              values={{
                LinkFormatting: MarketplaceLinkFormatting,
              }}
              description={{
                text: "First step to pause your shop",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={2}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Select <LinkFormatting>Shop settings</LinkFormatting>."
              values={{
                LinkFormatting: ShopSettingsLinkFormatting,
              }}
              description={{
                text: "Second step to pause your shop",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={3}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Scroll down to <BoldFormatting>Pause mode</BoldFormatting>."
              values={{
                BoldFormatting,
              }}
              description={{
                text: "Third step to pause your shop",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={4}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Choose the start and end dates for pausing your shop."
              description={{
                text: "Fourth step to pause your shop",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={5}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Select <BoldFormatting>Save</BoldFormatting> to confirm your changes."
              values={{
                BoldFormatting,
              }}
              description={{
                text: "Fifth step to pause your shop",
              }}
            />
          </Typography>
        </LiItem>
      </ol>
    </Column>
  );
};

const ShopSettingsLinkFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={brandPortalShopSettings()} target="_blank">
    <Bold>{chunks}</Bold>
  </Button>
);

const MarketplaceLinkFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={brandPortalMarketplace()} target="_blank">
    <Bold>{chunks}</Bold>
  </Button>
);

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;
